import Offcanvas from "react-bootstrap/Offcanvas";
import "bootstrap/dist/css/bootstrap.min.css";
import { RxCross2 } from "react-icons/rx";
import { customTextColor } from "../../utils/const";
import { Box, CircularProgress, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { getAllCandidate } from "../../redux/candidate/candidateSlice";
import { useDispatch, useSelector } from "react-redux";
import ApplyCandidateListCard from "./ApplyCandidateListCard";
import ApplyCandidateDetailsViewDrawer from "./ApplyCandidateDetailsViewDrawer";
import styles from "../Profile/Profile.module.css";

const ApplyCandidateListViewer = ({
  handleClose,
  show,
  handleOnClickApply,
  setCandidates,
  candidates,
}) => {
  const [submisionRow, setSubmisionRow] = useState({});
  const [showDetails, setShow] = useState(false);

  const handleCloseShow = () => setShow(false);
  const handleShow = () => setShow(true);

  const dispatch = useDispatch();
  const allCandiadate = useSelector((state) => state.candidate.data);
  const candidateStatus = useSelector((state) => state.candidate.status);
  const jobtimelineStatus = useSelector(
    (state) => state.jobtimeline?.viewStaus
  );

  useEffect(() => {
    dispatch(getAllCandidate());
  }, [dispatch]);

  const handleOnClickJobID = (row) => {
    handleShow();
    setSubmisionRow(row);
  };

  useEffect(() => {
    if (allCandiadate?.profiles) {
      // Add check property to each candidate
      const updatedCandidates = allCandiadate.profiles.map((c) => ({
        ...c,
        check: false,
      }));
      setCandidates(updatedCandidates);
    }
  }, [allCandiadate]);

  const handleCheckboxChange = (id) => {
    setCandidates((prevCandidates) =>
      prevCandidates.map((c) => (c.id === id ? { ...c, check: !c.check } : c))
    );
  };

  const handleSelectAll = () => {
    const allChecked = candidates.every((c) => c.check);
    setCandidates(candidates.map((c) => ({ ...c, check: !allChecked })));
  };

  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="end"
      scroll={false}
      backdrop={false}
      style={{
        border: "none",
        marginTop: "74px",
        width: "45%",
        padding: "0 0 0 10px",
        backgroundColor: "#fafafa",
        boxShadow: "-4px 0 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Offcanvas.Header
        style={{
          display: "flex",
          justifyContent: "end",
          alignItems: "center",
        }}
      >
        <RxCross2
          style={{
            fontSize: "22px",
            cursor: "pointer",
            alignSelf: "baseline",
            color: customTextColor,
          }}
          onClick={handleClose}
        />
      </Offcanvas.Header>
      <Offcanvas.Body style={{ paddingTop: "0" }}>
        {candidateStatus === "loading" ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: 50,
            }}
          >
            <CircularProgress size={30} color="info" />
          </Box>
        ) : candidates?.length > 0 ? (
          candidates?.map((candidate) => {
            return (
              <ApplyCandidateListCard
                candidate={candidate}
                handleOnClickJobID={handleOnClickJobID}
                handleCheckboxChange={handleCheckboxChange}
              />
            );
          })
        ) : (
          <h6 style={{ marginTop: "50px", textAlign: "center" }}>
            No Candidate Found
          </h6>
        )}
        <Box
          className={styles.internal_update_btns}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            padding: "10px",
          }}
        >
          <button
            style={{
              backgroundColor: "#3856a6",
              padding: "7px 20px ",
              border: "none",
              borderRadius: "3px",
              color: "#fff",
            }}
            onClick={handleOnClickApply}
          >
            {jobtimelineStatus === "loading" ? "Loading" : "Apply"}
          </button>
          <button
            style={{
              padding: "7px 18px",
              backgroundColor: "#3856a6",
              border: "none",
              borderRadius: "3px",
              color: "#fff",
            }}
            onClick={handleSelectAll}
          >
            {jobtimelineStatus === "loading" ? "Loading" : " Select All"}
          </button>
        </Box>
      </Offcanvas.Body>
      <ApplyCandidateDetailsViewDrawer
        handleShow={handleShow}
        handleClose={handleCloseShow}
        show={showDetails}
        row={submisionRow}
      />
    </Offcanvas>
  );
};

export default ApplyCandidateListViewer;
